<template>
	<div class="vx-row">
		<div class="vx-col w-full">
			<div class="widgets vx-row">
				<div
					class="vx-col w-full lg:w-2/3 xl:w-2/3"
					style="margin-bottom: 2.2rem;"
				>
					<vx-card>
						<div class="line-area-chart" slot="no-body">
							<span class="line-area-chart__title">{{
								$t("averageAnswerTimeBy")
							}}</span>
							<vue-apex-charts
								height="350px"
								ref="apexChart"
								type="bar"
								:options="chartOptionsList"
								:series="chartOptions.series"
							/>
						</div>
					</vx-card>
				</div>

				<div
					class="vx-col w-full md:w-1/2 lg:w-1/3 xl:w-1/3"
					style="margin-bottom: 2.2rem;"
				>
					<vx-card>
						<div class="vx-row">
							<div class="px-2 w-full">
								<WidgetCard
									v-for="widget in widgetsList"
									:key="widget.name"
									:text="widget.name"
									iconRight
									:icon="widget.icon"
									:color="widget.color"
									:statistic="widget.statistic"
									class="multi-item w-full"
								/>
							</div>
						</div>
					</vx-card>
				</div>
			</div>
		</div>

		<div class="vx-col w-full">
			<vx-card>
				<div class="vx-row py-2 justify-between">
					<div class="vx-col">
						<div class="perPage">
							<v-select
								class="single-row-select"
								v-model="tableMaxItems"
								label=""
								:searchable="false"
								:options="[20, 50, 100]"
							/>
						</div>
					</div>
				</div>

				<vs-table
					:max-items="tableMaxItems"
					pagination
					:data="table"
					class="table-th-center"
					:currentPage="currentPage"
					@change-page="setTablePageNumber"
				>
					<template slot="thead">
						<vs-th
							v-for="fil in answerTimeFields"
							class="justify-center text-center"
							:sort-key="fil.field.split('.')[0]"
							:key="fil.field"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in answerTimeFields">
								<vs-td
									v-if="fil.field === 'order_id'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<router-link
										v-if="tr.order_id"
										:to="'ticket/' + tr.order_id"
									>
										№ {{ tr.order_id }}
									</router-link>

									<span v-else>-</span>
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'chat_id'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<span
										:class="{ chat_empty: !tr.chat_id }"
										class="chat"
										@click="openChat(tr)"
									>
										{{ tr.chat_id || '-' }}
									</span>
								</vs-td>

								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-else-if="fil.field === 'manager'"
								>
									{{ tr[fil.field] ? tr[fil.field] : "-" }}
								</vs-td>

								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-else-if="fil.field === 'website'"
								>
									{{ tr[fil.field] }}
								</vs-td>

								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-else-if="fil.field === 'date'"
								>
									{{ tr[fil.field] }}
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'reply_time'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<span
										v-if="
											tr[fil.field] !== null &&
												tr[fil.field] !== undefined
										"
									>
										{{
											tr[fil.field] +
												" " +
												$t("minutesShort")
										}}
									</span>

									<span v-else class="danger">{{
										$t("noAnswer")
									}}</span>
								</vs-td>

								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-else
								>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>
		</div>
	</div>
</template>

<script>
import getAnswerTimeTableFields from "@/views/Stats/stats-utils/tables/answer-time-table-fields";
import VSelect from "vue-select";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import WidgetCard from "@/components/statistics-cards/WidgetCard";
import VueApexCharts from "vue-apexcharts";

export default {
	name: "AnswerTimeStatsComponent",
	components: {
		StatisticsCardLine,
		VSelect,
		WidgetCard,
		VueApexCharts
	},
	props: {
		table: { default: [], type: Array, required: true },
		currentPage: { default: 1, type: Number },
		widgets: { default: null, type: Object, required: true },
		chartOptions: { default: null, type: Object, required: true }
	},

	data() {
		return {
			answerTimeFields: getAnswerTimeTableFields(this),
			currentTablePage: 1,
			tableMaxItems: 20
		};
	},

	computed: {
		widgetsList() {
			return this.widgets.widgets.map(widget => {
				const value = widget.data ? widget.data : 0;

				return {
					code: widget.code,
					name: widget.name,
					statistic: value + " " + this.$t("minutesShort"),
					icon: widget.icon,
					color: widget.color
				};
			});
		},

		chartOptionsList() {
			return { ...this.chartOptions.options };
		}
	},

	methods: {
		setTablePageNumber(data) {
			this.$emit("update:currentPage", data);
			// this.currentTablePage = data;
		},

		openChat(item) {
			if (item.chat_id) {
				this.$store.dispatch("openChat", {
					userId: item.user_id,
					disabled: false
				});
      }
		}
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.line-area-chart {
	display: flex;
	flex-direction: column;

	&__title {
		font-weight: 600;
		font-size: 18px;
		margin-top: 10px;
		margin-left: 15px;
	}
}

.multi-item {
	margin-top: 10px;

	&:first-child {
		margin-top: 0;
	}
}

@media screen and (max-width: 992px) {
	.widgets {
		flex-direction: column-reverse;
	}
}

.danger {
	font-weight: 600;
	color: $danger;
}

.chat {
  color: rgba(var(--vs-primary), 1);
  cursor: pointer;

  &_empty {
    color: inherit;
    cursor: default;
  }
}
</style>
